export default {
      id: "operational_challenge_icon_wit_full-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#operational_challenge_icon_wit_full-usage",
      toString: function () {
        return this.url;
      }
    }